export const map = {
  CASH_EQUITY: "227dddaa-0fdf-4417-b132-7cde94233e6f",
  	STAGE: "04c04fda-a8c3-11e9-8b5f-00ff12c3b408",
  LENDER: "04c04feb-a8c3-11e9-8b5f-00ff12c3b408",
  DEBT_MF_UNIT: "04c04ff4-a8c3-11e9-8b5f-00ff12c3b408",
  LOAN_SPREAD: "04c04ffa-a8c3-11e9-8b5f-00ff12c3b408",
  ALL_IN_RATE: "04c05001-a8c3-11e9-8b5f-00ff12c3b408",
  TEAM_MEMBER: "7d8f0f35-3f5e-11e9-bf92-0242ac140002",
  STATE: "7d8f0fcd-3f5e-11e9-bf92-0242ac140002",
  CITY: "7d8f1066-3f5e-11e9-bf92-0242ac140002",
  MF_UNITS: "7d8f1100-3f5e-11e9-bf92-0242ac140002",
  SQUARE_FEET: "7d8f119a-3f5e-11e9-bf92-0242ac140002",
  ASSET_CLASS: "7d8f1237-3f5e-11e9-bf92-0242ac140002",
  ASSET_TYPE: "7d8f12d7-3f5e-11e9-bf92-0242ac140002",
  OCCUPANCY: "7d8f1377-3f5e-11e9-bf92-0242ac140002",
  NOI: "7d8f141a-3f5e-11e9-bf92-0242ac140002",
  NOI_ACTUAL: "fe2a5a37-c825-11e9-a4f9-00ff12c3b408",
  BROKER_COMPANY: "7d8f14bf-3f5e-11e9-bf92-0242ac140002",
  PURCHASE_PRICE: "7d8f1566-3f5e-11e9-bf92-0242ac140002",
  APPRAISED_VALUE: "7d8f176a-3f5e-11e9-bf92-0242ac140002",
  DESIRED_LOAN_AMOUNT: "7d8f18b1-3f5e-11e9-bf92-0242ac140002",
  FUND: "7d8f1a5d-3f5e-11e9-bf92-0242ac140002",
  STATUS: "7d8f1c30-3f5e-11e9-bf92-0242ac140002",
  TARGETED_CLOSE: "7d8f1ce9-3f5e-11e9-bf92-0242ac140002"
};
export const list = Object.values(map);
export default {
  map,
  list
};
